import React from 'react';
import CommandPalette from 'react-cmdk';
import styled from 'styled-components';
import { EmptyState } from 'components/atoms/empty-state';
import { CommandItem, CommandItemType } from './types';

const CommandItemWrapper = styled.div`
  margin-top: var(--spacing-01);
  margin-bottom: var(--spacing-01);

  span.text-gray-500.text-sm {
    display: none;
  }
  div.flex.w-full.items-center.space-x-2\.5 {
    @media (prefers-color-scheme: dark) {
      color: var(--white-100);
    }
  }
`;

const BannerItemWrapper = styled.div`
  padding: var(--spacing-05);
`;

export const Item: React.FC<{ commandItem: CommandItem; index: number }> = ({
  commandItem,
  index,
}) => {
  const onClick = () => {
    switch (commandItem.meta.type) {
      case CommandItemType.Navigate:
        {
          const a = document.createElement('a');

          a.setAttribute('href', commandItem.meta.link);
          // Commenting this now coz requirement is that we don't allow new tabs right now, If neeeded uncomment later
          // if (commandItem.meta.inNewTab) {
          //   a.setAttribute('target', '_blank');
          // }
          a.click();
        }
        break;

      case CommandItemType.Callback:
        commandItem.meta.callback?.();
        break;

      default:
        break;
    }
  };

  if (commandItem.meta.type === CommandItemType.Banner) {
    return (
      <BannerItemWrapper>
        <EmptyState
          image={commandItem.icon}
          title={commandItem.label}
          message={commandItem.desc}
          secondaryCTA={null}
        />
      </BannerItemWrapper>
    );
  }

  return (
    <CommandItemWrapper>
      <CommandPalette.ListItem
        icon={commandItem.icon}
        index={index}
        onClick={onClick}
      >
        {commandItem.label}
      </CommandPalette.ListItem>
    </CommandItemWrapper>
  );
};
